import { Venue, VenueAddress } from '@bam/sdk';

export class GoogleMaps {
  public static getLinkToVenue(venue: Venue) {
    return GoogleMaps.getSearchLinkWithParams(this.venueUrlParams(venue));
  }

  private static getSearchLinkWithParams(venueUrlParams: string) {
    return encodeURI(
      `https://www.google.com/maps/search/?api=1&query=${venueUrlParams}`
    );
  }

  private static venueUrlParams(venue: Venue) {
    return [venue?.name, GoogleMaps.venueData(venue?.address)]
      .filter((detail) => detail)
      .join(' ');
  }

  public static venueData(address: VenueAddress) {
    if (!address) {
      return;
    }
    const venueDetails = [
      address.street1,
      address.zip,
      address.city,
      address.state,
      address.country
    ];
    return venueDetails.filter((detail) => detail).join(', ');
  }
}
